import { APP_CONFIG, canDebugStuffState, clearAllCache, ROUTES } from '@sd/shared';
// eslint-disable-next-line no-restricted-imports
import { recoilCache } from '@sd/shared/src/state/recoilHelpers/recoilCache';
import { useState } from 'react';
import { Button, Modal, Tab, Tabs } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import styled from 'styled-components';
import { Icon } from '../Icon/Icon';
import { RecoilDebugger } from './RecoilState';
import { devOptionsState } from './state';

type Props = {
  className?: string;
  style?: React.CSSProperties;
};

export const DevMenu = (props: Props) => {
  const devOptions = useRecoilValue(devOptionsState);
  const [showModal, setShowModal] = useState(false);
  const history = useHistory();
  const canDebugStuff = useRecoilValue(canDebugStuffState);

  if (!canDebugStuff) return null;

  const optionsCount = Object.keys(devOptions).length;

  const allOptions = {
    ...devOptions,
    Recoil: <RecoilDebugger />
  };

  return (
    <div className={props.className} style={props.style}>
      <Button variant="link" size="sm" onClick={() => setShowModal(true)} title="Developer Menu">
        {!!optionsCount && <span>({optionsCount})</span>}
        <Icon variant="gear" className="ml-1" />
      </Button>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            Dev Menu - {APP_CONFIG.build.gitSha.substr(0, 7)} - {APP_CONFIG.build.buildTimestamp.toLocaleString()}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Top row of buttons */}
          <Menu>
            <MenuButton onClick={() => Object.values(recoilCache).forEach(c => c.clear())}>
              <Icon variant="trash" className="mr-1" />
              Clear Recoil Cache
            </MenuButton>
            <MenuButton onClick={() => clearAllCache()}>
              <Icon variant="minus-circle-o" className="mr-1" />
              Clear All Cache
            </MenuButton>
            <MenuButton onClick={() => history.push(ROUTES.appShell.logout.locationFor())}>
              <Icon variant="leave" className="mr-1" />
              Logout
            </MenuButton>
            <MenuButton variant="link" size="sm" onClick={() => window.location.reload()}>
              <Icon variant="refresh" title="Refresh Page" />
            </MenuButton>
          </Menu>
          <hr />
          {/* Page Specific Dev Options */}
          <Tabs defaultActiveKey={Object.keys(allOptions)[0]}>
            {Object.entries(allOptions).map(([name, children]) => (
              <Tab key={name} eventKey={name} title={name} className="pt-2">
                <div>{children}</div>
              </Tab>
            ))}
          </Tabs>
        </Modal.Body>
      </Modal>
    </div>
  );
};

const MenuButton = styled(Button).attrs({ variant: 'outline', size: 'sm' })``;

const Menu = styled.div.attrs({ className: 'd-flex justify-content-between' })``;
